import { selectors } from 'data'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import styled from 'styled-components'
import { screenWidth } from 'utils'

import SignedIn from './SignedIn'
import SignedOut from './SignedOut'

type PropsType = ConnectedProps<typeof connector>

const Container = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;

  @media only screen and (max-width: ${screenWidth('sm')}) {
    justify-content: right;
  }
`

const NavigationMenu = ({ isAuthenticated }: PropsType) => (
  <Container>{isAuthenticated ? <SignedIn /> : <SignedOut />}</Container>
)

const mapStateToProps = (state) => ({
  isAuthenticated: selectors.auth.isAuthenticated(state)
})

const connector = connect(mapStateToProps)

export default connector(NavigationMenu)
